import React from 'react'
import { Link } from 'react-router-dom'
import { providerIconFor } from './waitingListConstants'

export default function AccountCell({ row, className, onNavigate }) {
  const ProviderIcon = providerIconFor(row.provider)
  const handle = (
    <span className="block text-sm font-semibold text-rb-black dark:text-white group-hover:text-rb-green truncate" title={row.username}>
      @{row.username?.replace(/^@/, '')}
    </span>
  )

  return (
    <span className={`${className} flex items-center gap-2`}>
      <span className="shrink-0 text-rb-mat-grey dark:text-rb-dark-mode-text-grey" title={row.provider}>
        {ProviderIcon && <ProviderIcon />}
      </span>
      <span className="min-w-0">
        {row.authentication_id ? (
          <Link
            to={`/project_manager/authentications/${row.authentication_id}/influencer`}
            onClick={onNavigate}
            className="block group"
          >
            {handle}
          </Link>
        ) : handle}
        {row.full_name && (
          <span className="block text-xs text-rb-mat-grey dark:text-rb-dark-mode-text-grey truncate">{row.full_name}</span>
        )}
      </span>
    </span>
  )
}
